export const data = [
  {
    "country": "Algeria",
    "ISO2": "DZ",
    "ISO3": "DZA",
    "region": "Africa",
    "W10": false,
    "rank": null,
    "population": "45.6",
    "millionaires": 2800,
    "centiMillionaires": 8,
    "billionaires": 1,
    "actualHNWI": null,
    "forecastHNWI": null,
    "linkText": "",
    "link": "",
    "inflowRank":null,
    "outflowRank":null,
  },
  {
    "country": "Angola",
    "ISO2": "AO",
    "ISO3": "AGO",
    "region": "Africa",
    "W10": false,
    "rank": null,
    "population": "36.7",
    "millionaires": 2400,
    "centiMillionaires": 4,
    "billionaires": 0,
    "actualHNWI": null,
    "forecastHNWI": null,
    "linkText": "",
    "link": "",
    "inflowRank":null,
    "outflowRank":null,
  },
  {
    "country": "Argentina",
    "ISO2": "AR",
    "ISO3": "ARG",
    "region": "Americas",
    "W10": false,
    "rank": null,
    "population": "45.8",
    "millionaires": 21400,
    "centiMillionaires": 78,
    "billionaires": 3,
    "actualHNWI": -200,
    "forecastHNWI": -200,
    "linkText": "",
    "link": "",
    "inflowRank":null,
    "outflowRank":14,
  },
  {
    "country": "Australia",
    "ISO2": "AU",
    "ISO3": "AUS",
    "region": "Asia Pacific",
    "W10": 1,
    "rank": 7,
    "population": "26.4",
    "millionaires": 375800,
    "centiMillionaires": 454,
    "billionaires": 36,
    "actualHNWI": 3800,
    "forecastHNWI": 5200,
    "linkText": "Apply for residence in Australia",
    "link": "https://www.henleyglobal.com/residence-investment/australia",
    "inflowRank":1,
    "outflowRank":null,
  },
  {
    "country": "Botswana",
    "ISO2": "BW",
    "ISO3": "BWA",
    "region": "Africa",
    "W10": false,
    "rank": null,
    "population": "2.7",
    "millionaires": 1900,
    "centiMillionaires": 2,
    "billionaires": 0,
    "actualHNWI": null,
    "forecastHNWI": null,
    "linkText": "",
    "link": "",
    "inflowRank":null,
    "outflowRank":null,
  },
  {
    "country": "Brazil",
    "ISO2": "BR",
    "ISO3": "BRA",
    "region": "Americas",
    "W10": false,
    "rank": null,
    "population": "216.4",
    "millionaires": 96900,
    "centiMillionaires": 240,
    "billionaires": 28,
    "actualHNWI": -1800,
    "forecastHNWI": -1200,
    "linkText": "",
    "link": "",
    "inflowRank":null,
    "outflowRank":5,
  },
  {
    "country": "Canada",
    "ISO2": "CA",
    "ISO3": "CAN",
    "region": "Americas",
    "W10": 1,
    "rank": 8,
    "population": "38.8",
    "millionaires": 367500,
    "centiMillionaires": 529,
    "billionaires": 43,
    "actualHNWI": 1200,
    "forecastHNWI": 1600,
    "linkText": "Apply for residence in Canada",
    "link": "https://www.henleyglobal.com/residence-investment/canada",
    "inflowRank":6,
    "outflowRank":null,
  },
  {
    "country": "Chile",
    "ISO2": "CL",
    "ISO3": "CHL",
    "region": null,
    "W10": null,
    "rank": null,
    "population": null,
    "millionaires": null,
    "centiMillionaires": null,
    "billionaires": null,
    "actualHNWI": -100,
    "forecastHNWI": -100,
    "linkText": "",
    "link": "",
    "inflowRank":null,
    "outflowRank":18,
  },
  {
    "country": "China",
    "ISO2": "CN",
    "ISO3": "CHN",
    "region": "Asia Pacific",
    "W10": 1,
    "rank": 3,
    "population": "1425.7",
    "millionaires": 780000,
    "centiMillionaires": 2250,
    "billionaires": 285,
    "actualHNWI": -10800,
    "forecastHNWI": -13500,
    "linkText": "",
    "link": "",
    "inflowRank":null,
    "outflowRank":1,
  },
  {
    "country": "Colombia",
    "ISO2": "CO",
    "ISO3": "COL",
    "region": "Americas",
    "W10": false,
    "rank": null,
    "population": "52.1",
    "millionaires": 17600,
    "centiMillionaires": 64,
    "billionaires": 3,
    "actualHNWI": -100,
    "forecastHNWI": -100,
    "linkText": "",
    "link": "",
    "inflowRank":null,
    "outflowRank":17,
  },
  {
    "country": "Congo (Dem. Rep.)",
    "ISO2": "CD",
    "ISO3": "COD",
    "region": "Africa",
    "W10": false,
    "rank": null,
    "population": "102.3",
    "millionaires": 600,
    "centiMillionaires": 1,
    "billionaires": 0,
    "actualHNWI": null,
    "forecastHNWI": null,
    "linkText": "",
    "link": "",
    "inflowRank":null,
    "outflowRank":null,
  },
  {
    "country": "Cote d'Ivoire",
    "ISO2": "CI",
    "ISO3": "CIV",
    "region": "Africa",
    "W10": false,
    "rank": null,
    "population": "28.9",
    "millionaires": 2200,
    "centiMillionaires": 4,
    "billionaires": 0,
    "actualHNWI": null,
    "forecastHNWI": null,
    "linkText": "",
    "link": "",
    "inflowRank":null,
    "outflowRank":null,
  },
  {
    "country": "Egypt",
    "ISO2": "EG",
    "ISO3": "EGY",
    "region": "Africa",
    "W10": false,
    "rank": null,
    "population": "112.7",
    "millionaires": 16100,
    "centiMillionaires": 54,
    "billionaires": 8,
    "actualHNWI": -200,
    "forecastHNWI": -200,
    "linkText": "",
    "link": "",
    "inflowRank":null,
    "outflowRank":15,
  },
  {
    "country": "Ethiopia",
    "ISO2": "ET",
    "ISO3": "ETH",
    "region": "Africa",
    "W10": false,
    "rank": null,
    "population": "126.5",
    "millionaires": 2700,
    "centiMillionaires": 4,
    "billionaires": 0,
    "actualHNWI": null,
    "forecastHNWI": null,
    "linkText": "",
    "link": "",
    "inflowRank":null,
    "outflowRank":null,
  },
  {
    "country": "France",
    "ISO2": "FR",
    "ISO3": "FRA",
    "region": "Europe & CIS",
    "W10": 1,
    "rank": 9,
    "population": "64.8",
    "millionaires": 357000,
    "centiMillionaires": 410,
    "billionaires": 35,
    "actualHNWI": 500,
    "forecastHNWI": 1000,
    "linkText": "",
    "link": "",
    "inflowRank":8,
    "outflowRank":null,
  },
  {
    "country": "Germany",
    "ISO2": "DE",
    "ISO3": "DEU",
    "region": "Europe & CIS",
    "W10": 1,
    "rank": 4,
    "population": "83.3",
    "millionaires": 767700,
    "centiMillionaires": 1024,
    "billionaires": 78,
    "actualHNWI": 200,
    "forecastHNWI": 400,
    "linkText": "",
    "link": "",
    "inflowRank":13,
    "outflowRank":null,
  },
  {
    "country": "Ghana",
    "ISO2": "GH",
    "ISO3": "GHA",
    "region": "Africa",
    "W10": false,
    "rank": null,
    "population": "34.1",
    "millionaires": 2600,
    "centiMillionaires": 5,
    "billionaires": 0,
    "actualHNWI": -100,
    "forecastHNWI": -100,
    "linkText": "",
    "link": "",
    "inflowRank":null,
    "outflowRank":20,
  },
  {
    "country": "Greece",
    "ISO2": "GR",
    "ISO3": "GRC",
    "region": "Europe & CIS",
    "W10": false,
    "rank": null,
    "population": "10.3",
    "millionaires": 58800,
    "centiMillionaires": 95,
    "billionaires": 4,
    "actualHNWI": 1000,
    "forecastHNWI": 1200,
    "linkText": "Apply for residence in Greece",
    "link": "https://www.henleyglobal.com/residence-investment/greece",
    "inflowRank":7,
    "outflowRank":null,
  },
  {
    "country": "Hong Kong (SAR China)",
    "ISO2": "HK",
    "ISO3": "HKG",
    "region": "Asia Pacific",
    "W10": false,
    "rank": null,
    "population": "7.5",
    "millionaires": 129500,
    "centiMillionaires": 290,
    "billionaires": 32,
    "actualHNWI": -2400,
    "forecastHNWI": -1000,
    "linkText": "Apply for residence in Hong Kong (SAR China)",
    "link": "https://www.henleyglobal.com/residence-investment/hong-kong",
    "inflowRank":null,
    "outflowRank":6,
  },
  {
    "country": "Hungary",
    "ISO2": "HU",
    "ISO3": "HUN",
    "region": "Europe & CIS",
    "W10": false,
    "rank": null,
    "population": "10.2",
    "millionaires": 12100,
    "centiMillionaires": 23,
    "billionaires": 0,
    "actualHNWI": null,
    "forecastHNWI": null,
    "linkText": "",
    "link": "",
    "inflowRank":null,
    "outflowRank":null,
  },
  {
    "country": "India",
    "ISO2": "IN",
    "ISO3": "IND",
    "region": "Asia Pacific",
    "W10": 1,
    "rank": 10,
    "population": "1428.6",
    "millionaires": 344600,
    "centiMillionaires": 1078,
    "billionaires": 123,
    "actualHNWI": -7500,
    "forecastHNWI": -6500,
    "linkText": "",
    "link": "",
    "inflowRank":null,
    "outflowRank":2,
  },
  {
    "country": "Indonesia",
    "ISO2": "ID",
    "ISO3": "IDN",
    "region": null,
    "W10": null,
    "rank": null,
    "population": null,
    "millionaires": null,
    "centiMillionaires": null,
    "billionaires": null,
    "actualHNWI": -400,
    "forecastHNWI": -200,
    "linkText": "",
    "link": "",
    "inflowRank":null,
    "outflowRank":13,
  },
  {
    "country": "Ireland",
    "ISO2": "IE",
    "ISO3": "IRL",
    "region": "Europe & CIS",
    "W10": false,
    "rank": null,
    "population": "5.1",
    "millionaires": 48500,
    "centiMillionaires": 83,
    "billionaires": 9,
    "actualHNWI": 100,
    "forecastHNWI": null,
    "linkText": "",
    "link": "",
    "inflowRank":null,
    "outflowRank":null,
  },
  {
    "country": "Israel",
    "ISO2": "IL",
    "ISO3": "ISR",
    "region": "Middle East",
    "W10": false,
    "rank": null,
    "population": "9.2",
    "millionaires": 80800,
    "centiMillionaires": 235,
    "billionaires": 23,
    "actualHNWI": 1100,
    "forecastHNWI": 600,
    "linkText": "",
    "link": "",
    "inflowRank":12,
    "outflowRank":null,
  },
  {
    "country": "Italy",
    "ISO2": "IT",
    "ISO3": "ITA",
    "region": "Europe & CIS",
    "W10": false,
    "rank": null,
    "population": "58.9",
    "millionaires": 263000,
    "centiMillionaires": 326,
    "billionaires": 32,
    "actualHNWI": 300,
    "forecastHNWI": 600,
    "linkText": "Apply for residence in Italy",
    "link": "https://www.henleyglobal.com/residence-investment/italy",
    "inflowRank":11,
    "outflowRank":null,
  },
  {
    "country": "Japan",
    "ISO2": "JP",
    "ISO3": "JPN",
    "region": "Asia Pacific",
    "W10": 1,
    "rank": 2,
    "population": "123.3",
    "millionaires": 952000,
    "centiMillionaires": 733,
    "billionaires": 38,
    "actualHNWI": -100,
    "forecastHNWI": -300,
    "linkText": "",
    "link": "",
    "inflowRank":null,
    "outflowRank":10,
  },
  {
    "country": "Kenya",
    "ISO2": "KE",
    "ISO3": "KEN",
    "region": "Africa",
    "W10": false,
    "rank": null,
    "population": "55.1",
    "millionaires": 7700,
    "centiMillionaires": 15,
    "billionaires": 0,
    "actualHNWI": -100,
    "forecastHNWI": -100,
    "linkText": "",
    "link": "",
    "inflowRank":null,
    "outflowRank":19
  },
  {
    "country": "Luxembourg",
    "ISO2": "LU",
    "ISO3": "LUX",
    "region": "Europe & CIS",
    "W10": false,
    "rank": null,
    "population": "0.7",
    "millionaires": 43300,
    "centiMillionaires": 109,
    "billionaires": 7,
    "actualHNWI": 100,
    "forecastHNWI": 100,
    "linkText": "Apply for residence in Luxembourg",
    "link": "https://www.henleyglobal.com/residence-investment/luxembourg",
    "inflowRank":19,
    "outflowRank":null,
  },
  {
    "country": "Malta",
    "ISO2": "MT",
    "ISO3": "MLT",
    "region": "Europe & CIS",
    "W10": false,
    "rank": null,
    "population": "0.5",
    "millionaires": 9100,
    "centiMillionaires": 26,
    "billionaires": 2,
    "actualHNWI": 200,
    "forecastHNWI": 200,
    "linkText": "Apply for citizenship in Malta",
    "link": "https://www.henleyglobal.com/citizenship-investment/malta",
    "inflowRank":17,
    "outflowRank":null,
  },
  {
    "country": "Mauritius",
    "ISO2": "MU",
    "ISO3": "MUS",
    "region": "Africa",
    "W10": false,
    "rank": null,
    "population": "1.3",
    "millionaires": 4900,
    "centiMillionaires": 10,
    "billionaires": 0,
    "actualHNWI": 200,
    "forecastHNWI": 200,
    "linkText": "Apply for residence in Mauritius",
    "link": "https://www.henleyglobal.com/residence-investment/mauritius",
    "inflowRank":18,
    "outflowRank":null,
  },
  {
    "country": "Mexico",
    "ISO2": "MX",
    "ISO3": "MEX",
    "region": "Americas",
    "W10": false,
    "rank": null,
    "population": "128.5",
    "millionaires": 112200,
    "centiMillionaires": 194,
    "billionaires": 17,
    "actualHNWI": -800,
    "forecastHNWI": -700,
    "linkText": "",
    "link": "",
    "inflowRank":null,
    "outflowRank":8,
  },
  {
    "country": "Monaco",
    "ISO2": "MC",
    "ISO3": "MCO",
    "region": "Europe & CIS",
    "W10": false,
    "rank": null,
    "population": "0.0",
    "millionaires": 17600,
    "centiMillionaires": 165,
    "billionaires": 20,
    "actualHNWI": 300,
    "forecastHNWI": 400,
    "linkText": "Apply for residence in Monaco",
    "link": "https://www.henleyglobal.com/residence-investment/monaco",
    "inflowRank":15,
    "outflowRank":null,
  },
  {
    "country": "Morocco",
    "ISO2": "MA",
    "ISO3": "MAR",
    "region": "Africa",
    "W10": false,
    "rank": null,
    "population": "37.8",
    "millionaires": 5800,
    "centiMillionaires": 28,
    "billionaires": 4,
    "actualHNWI": 100,
    "forecastHNWI": 100,
    "linkText": "",
    "link": "",
    "inflowRank":20,
    "outflowRank":null,
  },
  {
    "country": "Mozambique",
    "ISO2": "MZ",
    "ISO3": "MOZ",
    "region": "Africa",
    "W10": false,
    "rank": null,
    "population": "33.9",
    "millionaires": 1100,
    "centiMillionaires": 2,
    "billionaires": 0,
    "actualHNWI": null,
    "forecastHNWI": null,
    "linkText": "",
    "link": "",
    "inflowRank":null,
    "outflowRank":null,
  },
  {
    "country": "Namibia",
    "ISO2": "NA",
    "ISO3": "NAM",
    "region": "Africa",
    "W10": false,
    "rank": null,
    "population": "2.6",
    "millionaires": 2100,
    "centiMillionaires": 3,
    "billionaires": 0,
    "actualHNWI": null,
    "forecastHNWI": null,
    "linkText": "Apply for residence in Namibia",
    "link": "https://www.henleyglobal.com/residence-investment/namibia",
    "inflowRank":null,
    "outflowRank":null,
  },
  {
    "country": "Netherlands",
    "ISO2": "NL",
    "ISO3": "NLD",
    "region": "Europe & CIS",
    "W10": false,
    "rank": null,
    "population": "17.6",
    "millionaires": 88400,
    "centiMillionaires": 166,
    "billionaires": 12,
    "actualHNWI": 200,
    "forecastHNWI": 200,
    "linkText": "",
    "link": "",
    "inflowRank":16,
    "outflowRank":null,
  },
  {
    "country": "New Zealand",
    "ISO2": "NZ",
    "ISO3": "NZL",
    "region": "Asia Pacific",
    "W10": false,
    "rank": null,
    "population": "5.2",
    "millionaires": 78400,
    "centiMillionaires": 108,
    "billionaires": 4,
    "actualHNWI": 800,
    "forecastHNWI": 700,
    "linkText": "Apply for residence in New Zealand",
    "link": "https://www.henleyglobal.com/residence-investment/new-zealand",
    "inflowRank":10,
    "outflowRank":null,
  },
  {
    "country": "Nigeria",
    "ISO2": "NG",
    "ISO3": "NGA",
    "region": "Africa",
    "W10": false,
    "rank": null,
    "population": "223.8",
    "millionaires": 9800,
    "centiMillionaires": 27,
    "billionaires": 4,
    "actualHNWI": -200,
    "forecastHNWI": -300,
    "linkText": "",
    "link": "",
    "inflowRank":null,
    "outflowRank":12,
  },
  {
    "country": "Poland",
    "ISO2": "PL",
    "ISO3": "POL",
    "region": "Europe & CIS",
    "W10": false,
    "rank": null,
    "population": "41.0",
    "millionaires": 50700,
    "centiMillionaires": 87,
    "billionaires": 6,
    "actualHNWI": null,
    "forecastHNWI": null,
    "linkText": "",
    "link": "",
    "inflowRank":null,
    "outflowRank":null,
  },
  {
    "country": "Portugal",
    "ISO2": "PT",
    "ISO3": "PRT",
    "region": "Europe & CIS",
    "W10": false,
    "rank": null,
    "population": "10.2",
    "millionaires": 65200,
    "centiMillionaires": 105,
    "billionaires": 6,
    "actualHNWI": 1400,
    "forecastHNWI": 800,
    "linkText": "Apply for residence in Portugal",
    "link": "https://www.henleyglobal.com/residence-investment/portugal",
    "inflowRank":9,
    "outflowRank":null,
  },
  {
    "country": "Qatar",
    "ISO2": "QA",
    "ISO3": "QAT",
    "region": "Middle East",
    "W10": false,
    "rank": null,
    "population": "2.7",
    "millionaires": 26100,
    "centiMillionaires": 56,
    "billionaires": 3,
    "actualHNWI": null,
    "forecastHNWI": null,
    "linkText": "",
    "link": "",
    "inflowRank":null,
    "outflowRank":null,
  },
  {
    "country": "Russian Federation",
    "ISO2": "RU",
    "ISO3": "RUS",
    "region": "Europe & CIS",
    "W10": false,
    "rank": null,
    "population": "144.4",
    "millionaires": 67700,
    "centiMillionaires": 405,
    "billionaires": 43,
    "actualHNWI": -8500,
    "forecastHNWI": -3000,
    "linkText": "",
    "link": "",
    "inflowRank":null,
    "outflowRank":4,
  },
  {
    "country": "Rwanda",
    "ISO2": "RW",
    "ISO3": "RWA",
    "region": "Africa",
    "W10": false,
    "rank": null,
    "population": "14.1",
    "millionaires": 1000,
    "centiMillionaires": 2,
    "billionaires": 0,
    "actualHNWI": null,
    "forecastHNWI": null,
    "linkText": "",
    "link": "",
    "inflowRank":null,
    "outflowRank":null,
  },
  {
    "country": "Saudi Arabia",
    "ISO2": "SA",
    "ISO3": "SAU",
    "region": "Middle East",
    "W10": false,
    "rank": null,
    "population": "36.9",
    "millionaires": 51600,
    "centiMillionaires": 168,
    "billionaires": 20,
    "actualHNWI": -600,
    "forecastHNWI": -100,
    "linkText": "",
    "link": "",
    "inflowRank":null,
    "outflowRank":16,
  },
  {
    "country": "Seychelles",
    "ISO2": "SC",
    "ISO3": "SYC",
    "region": "Africa",
    "W10": false,
    "rank": null,
    "population": "0.1",
    "millionaires": 400,
    "centiMillionaires": 5,
    "billionaires": 0,
    "actualHNWI": null,
    "forecastHNWI": null,
    "linkText": "",
    "link": "",
    "inflowRank":null,
    "outflowRank":null,
  },
  {
    "country": "Singapore",
    "ISO2": "SG",
    "ISO3": "SGP",
    "region": "Asia Pacific",
    "W10": false,
    "rank": null,
    "population": "6.0",
    "millionaires": 240100,
    "centiMillionaires": 329,
    "billionaires": 27,
    "actualHNWI": 2900,
    "forecastHNWI": 3200,
    "linkText": "Apply for residence in Singapore",
    "link": "https://www.henleyglobal.com/residence-investment/singapore",
    "inflowRank":3,
    "outflowRank":null,
  },
  {
    "country": "South Africa",
    "ISO2": "ZA",
    "ISO3": "ZAF",
    "region": "Africa",
    "W10": false,
    "rank": null,
    "population": "60.4",
    "millionaires": 37800,
    "centiMillionaires": 98,
    "billionaires": 5,
    "actualHNWI": -400,
    "forecastHNWI": -500,
    "linkText": "",
    "link": "",
    "inflowRank":null,
    "outflowRank":9,
  },
  {
    "country": "South Korea",
    "ISO2": "KR",
    "ISO3": "KOR",
    "region": "Asia Pacific",
    "W10": false,
    "rank": null,
    "population": "51.8",
    "millionaires": 128900,
    "centiMillionaires": 274,
    "billionaires": 27,
    "actualHNWI": -400,
    "forecastHNWI": -800,
    "linkText": "",
    "link": "",
    "inflowRank":null,
    "outflowRank":7,
  },
  {
    "country": "Spain",
    "ISO2": "ES",
    "ISO3": "ESP",
    "region": "Europe & CIS",
    "W10": false,
    "rank": null,
    "population": "47.5",
    "millionaires": 102200,
    "centiMillionaires": 187,
    "billionaires": 16,
    "actualHNWI": 200,
    "forecastHNWI": 400,
    "linkText": "Apply for residence in Spain",
    "link": "https://www.henleyglobal.com/residence-investment/spain",
    "inflowRank":14,
    "outflowRank":null,
  },
  {
    "country": "Switzerland",
    "ISO2": "CH",
    "ISO3": "CHE",
    "region": "Europe & CIS",
    "W10": 1,
    "rank": 6,
    "population": "8.8",
    "millionaires": 450200,
    "centiMillionaires": 768,
    "billionaires": 40,
    "actualHNWI": 2200,
    "forecastHNWI": 1800,
    "linkText": "Apply for residence in Switzerland",
    "link": "https://www.henleyglobal.com/residence-investment/switzerland",
    "inflowRank":5,
    "outflowRank":null,
  },
  {
    "country": "Tanzania",
    "ISO2": "TZ",
    "ISO3": "TZA",
    "region": "Africa",
    "W10": false,
    "rank": null,
    "population": "67.4",
    "millionaires": 2400,
    "centiMillionaires": 6,
    "billionaires": 1,
    "actualHNWI": null,
    "forecastHNWI": null,
    "linkText": "",
    "link": "",
    "inflowRank":null,
    "outflowRank":null,
  },
  {
    "country": "Türkiye",
    "ISO2": "TR",
    "ISO3": "TUR",
    "region": "Europe & CIS",
    "W10": false,
    "rank": null,
    "population": "85.8",
    "millionaires": 44500,
    "centiMillionaires": 145,
    "billionaires": 18,
    "actualHNWI": 300,
    "forecastHNWI": null,
    "linkText": "Apply for citizenship in Türkiye",
    "link": "https://www.henleyglobal.com/citizenship-investment/turkey",
    "inflowRank":null,
    "outflowRank":null,
  },
  {
    "country": "UAE",
    "ISO2": "AE",
    "ISO3": "ARE",
    "region": "Middle East",
    "W10": false,
    "rank": null,
    "population": "9.5",
    "millionaires": 109900,
    "centiMillionaires": 298,
    "billionaires": 20,
    "actualHNWI": 5200,
    "forecastHNWI": 4500,
    "linkText": "Apply for residence in the UAE",
    "link": "https://www.henleyglobal.com/residence-investment/united-arab-emirates",
    "inflowRank":2,
    "outflowRank":null,
  },
  {
    "country": "Uganda",
    "ISO2": "UG",
    "ISO3": "UGA",
    "region": "Africa",
    "W10": false,
    "rank": null,
    "population": "48.6",
    "millionaires": 1500,
    "centiMillionaires": 5,
    "billionaires": 0,
    "actualHNWI": null,
    "forecastHNWI": null,
    "linkText": "",
    "link": "",
    "inflowRank":null,
    "outflowRank":null,
  },
  {
    "country": "UK",
    "ISO2": "GB",
    "ISO3": "GBR",
    "region": "Europe & CIS",
    "W10": 1,
    "rank": 5,
    "population": "67.7",
    "millionaires": 651700,
    "centiMillionaires": 922,
    "billionaires": 92,
    "actualHNWI": -1600,
    "forecastHNWI": -3200,
    "linkText": "Apply for residence in the UK",
    "link": "https://www.henleyglobal.com/residence-investment/united-kingdom",
    "inflowRank":null,
    "outflowRank":3,
  },
  {
    "country": "USA",
    "ISO2": "US",
    "ISO3": "USA",
    "region": "Americas",
    "W10": 1,
    "rank": 1,
    "population": "340.0",
    "millionaires": 5270000,
    "centiMillionaires": 9630,
    "billionaires": 770,
    "actualHNWI": 1500,
    "forecastHNWI": 2100,
    "linkText": "Apply for residence in the USA",
    "link": "https://www.henleyglobal.com/residence-investment/united-states",
    "inflowRank":4,
    "outflowRank":null,
  },
  {
    "country": "Vietnam",
    "ISO2": "VN",
    "ISO3": "VNM",
    "region": "Asia Pacific",
    "W10": false,
    "rank": null,
    "population": "98.9",
    "millionaires": 18500,
    "centiMillionaires": 27,
    "billionaires": 4,
    "actualHNWI": -200,
    "forecastHNWI": -300,
    "linkText": "",
    "link": "",
    "inflowRank":null,
    "outflowRank":11,
  },
  {
    "country": "Zambia",
    "ISO2": "ZM",
    "ISO3": "ZMB",
    "region": "Africa",
    "W10": false,
    "rank": null,
    "population": "20.6",
    "millionaires": 900,
    "centiMillionaires": 3,
    "billionaires": 0,
    "actualHNWI": null,
    "forecastHNWI": null,
    "linkText": "",
    "link": "",
    "inflowRank":null,
    "outflowRank":null,
  }
]